'use client'

import clsx from 'clsx'
import React, { forwardRef, memo, useImperativeHandle, useRef } from 'react'
import Base from '../Base/Base'
import { BaseProps } from '../types'

export interface GridProps extends BaseProps {
  children?: React.ReactNode
  ref?: React.RefObject<HTMLElement>
}

const Grid = forwardRef<HTMLElement, GridProps>(
  ({ children, className, ...props }, ref) => {
    const comp = useRef<any>(null)
    useImperativeHandle(ref, () => comp.current as HTMLElement)

    return (
      <Base
        ref={comp}
        className={clsx('gap-gutter grid grid-cols-12', className)}
        {...props}
      >
        {children}
      </Base>
    )
  }
)
Grid.displayName = 'Grid'

export default memo(Grid)
